// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal .v-card[data-v-2aa4094c]{border-radius:0;box-shadow:inset 0 4px 0 0 #75943f}.modal h3[data-v-2aa4094c],.modal h4[data-v-2aa4094c]{font-size:30px}.modal .text[data-v-2aa4094c]{padding:1rem 0}.modal .v-card-actions[data-v-2aa4094c]{display:flex;box-shadow:inset 0 2px 0 0 #000,inset 0 -2px 0 0 #000}.modal .v-card-actions>button[data-v-2aa4094c]{flex-grow:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
